export default {
      id: "id-usage",
      viewBox: "0 0 70 48",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#id",
      toString: function () {
        return this.url;
      }
    }